export const messagePreviewContainerStyle = () => {
  return {
    width: '360px',
  };
};
